module.exports = __webpack_public_path__ + "static/jeanine-008-f34462713a35fec07ee793cbd1215a60.jpg";